import React from 'react'
import { HelpModal } from '../help/help-modal.component'

export const SuccessAlert = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='Success!'>
    Thanks for updating your information!
  </HelpModal>